import React, { useEffect, useState } from 'react';
import { ModalHeader, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useForm from '../CustomHooks/useForm';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      minWidth: 500,
    },
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #0a1e42 0%, #0b5fad 50%, #3a8ac4 100%)',
    color: 'white',
    padding: '16px 24px',
    textAlign: 'center',
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
  modalBody: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  submitButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'none',
    backgroundColor: '#0055A2',
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#003d75',
      boxShadow: 'none',
    },
  },
}));

const ResendActivationModal = (props) => {
  const classes = useStyles();

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.dialogTitle} style={{ position: 'relative' }} {...other}>
        <Typography variant="h6" style={{ color: 'white', fontFamily: 'Montserrat, sans-serif', fontWeight: 700 }}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  const resendActivation = () => {
    props.handleSendActivations();
    props.toggle();
  };

  return (
    <Dialog
      className={classes.dialog}
      onClose={props.toggle}
      aria-labelledby="customized-dialog-title"
      open={props.isOpen}
    >
      <DialogTitle id="customized-dialog-title" onClose={props.toggle}>
        {getTranslation('Resend Activation Instructions?', preferredLanguage)}
      </DialogTitle>

      <div className={classes.modalBody}>
        <Button
          onClick={resendActivation}
          id="deleteAllSelected"
          fullWidth
          variant="contained"
          className={classes.submitButton}
        >
          {getTranslation('Yes', preferredLanguage)}
        </Button>
      </div>
    </Dialog>
  );
};
export default ResendActivationModal;

//< div className = "ModalForm" >

//    <FormGroup check >
//        <input check style={{ marginLeft: '5px' }} type="checkbox" checked={props.isUserDeleteChecked} onClick={() => props.setIsUserDeleteChecked(!props.isUserDeleteChecked)}  ></input>
//        <Label check style={{ fontSize: '14px', marginLeft: '8px', padding: '5px' }} for="confirmDeleteCheck">Yes, I want to resend activation instructions to these users.</Label>
//    </FormGroup>

//                </div >
